import axios from "axios";

// Runtime override (set in /public/config.js for static cPanel deployment),
// falls back to build-time env var (used by Emergent / local dev).
// Use "same origin" when explicitly set to empty string.
const _runtime = (typeof window !== "undefined" ? window.__BACKEND_URL__ : undefined);
const BACKEND_URL =
  (_runtime !== undefined ? _runtime : process.env.REACT_APP_BACKEND_URL) || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  if (typeof window === "undefined") return cfg;
  const t = localStorage.getItem("tara_token");
  const at = localStorage.getItem("tara_agent_token");
  if (cfg.url?.startsWith("/agents/") || cfg.url?.startsWith("/agents")) {
    if (at) cfg.headers.Authorization = `Bearer ${at}`;
  } else if (cfg.url?.startsWith("/admin/")) {
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  } else {
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Resolve possibly-relative /api/assets/... URL to full backend URL */
export function resolveAssetUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}
